module.exports = __webpack_public_path__ + "img/グループ 227.012851a2.png";